<template>
  <m-badge :type="type"><slot /></m-badge>
</template>

<script>

const ItemStatusBadges = {
  STARTED: 'YELLOW',
  IN_PROGRESS: 'BLUE',
  NEEDS_REVIEW: 'RED',
  COMPLETED: 'GREEN',
};

export default {
  name: 'MBadgeStatus',
  props: {
    state: {
      type: String,
      default: 'STARTED',
    },
  },
  computed: {
    type() {
      return ItemStatusBadges[this.state];
    },
  },
};
</script>
